import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-titan-menu',
  templateUrl: './titan-menu.component.html',
  styleUrls: ['./titan-menu.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TitanMenuComponent {}
